import { CesiumTerrainProvider, Color, createElevationBandMaterial, EllipsoidTerrainProvider, Viewer } from "cesium";
import { createUUID } from "../../utils/utils";
import '../../styles/mapWeather/mapTerrain.css'
import { getMessage } from "../../language";
interface IInputMapTerrain {
    viewer: Viewer,
    containerId: string

}

export class MapTerrain {
    private _inputMapTerrain: IInputMapTerrain
    private _containerView: HTMLElement | undefined
    private _idGeneral = createUUID()
    checkboxTerrain = false
    checkboxDepth = true
    valueTransparentGlobe: number = 0.0

    constructor(input: IInputMapTerrain) {
        this._inputMapTerrain = input
        this._containerView = document.querySelector(`#${input.containerId}`) as HTMLElement

    }
    //#region createDataMapTerrain
    createDataMapTerrain = () => {
        const innerTextTerrain = ` 
        <div class='DPU-container-terrain'>
            <div class='DPU-container-checkbox'>
                <div class='checkbox-container'>
                    <input type="checkbox" class="dpu-input-check-box" id="terrain-${this._idGeneral}" ${this.checkboxTerrain ? "checked" : ""}>
                    <label for="terrain-${this._idGeneral}">${getMessage("map-terrain")}</label>
                </div>

                <div class='checkbox-container'>
                    <input type="checkbox" class="dpu-input-check-box" id="terrain-depth-${this._idGeneral}" ${this.checkboxDepth ? "checked" : ""}>
                    <label for="terrain-depth-${this._idGeneral}">${getMessage("map-through-group")}</label>
                </div>
            </div>

            <div class="container-range-transparent-globe">
                <label>${getMessage("map-group-transparent")}:</label>        
                <input type="range" id="transparent-globe-${this._idGeneral}" class="dpu-input-range" min="0" max="1" step="0.01" value="${this.valueTransparentGlobe}">
            </div>

        </div>
            `
        return innerTextTerrain


        //     <div style='width:100%;margin-top: 5px;'>
        //     <label>Cường điệu độ cao:</label>                            
        //     <input class="dpu-input-text" id="exaggeration-input-${this._idGeneral}"  type="number"  value="1" min="1" step="0.1">
        // </div>
    }
    //#endregion

    //#region createActionMapTerrain  
    private _inputTransparentGlobe: any
    createActionMapTerrain = () => {
        this.handleCheckBoxTerrain()
        this.handleCheckBoxDepth()

        this._inputTransparentGlobe = this._containerView?.querySelector(`#transparent-globe-${this._idGeneral}`)
        // this._inputExaggeration.addEventListener("input", this._validateInputExaggeration)
        this._inputTransparentGlobe.addEventListener("input", (event: Event) => {
            this.validateTransparentGlobe(event)

        })
        this.checkBoxTerrain(this.checkboxTerrain)
        this.checkBoxDepth(this.checkboxDepth)

        this.actionTransparentGlobe(this.valueTransparentGlobe)

    }

    //#endregion

    //#region _handleCheckBoxTerrain
    handleCheckBoxTerrain = () => {
        const checkBox = this._containerView?.querySelector(`#terrain-${this._idGeneral}`) as HTMLInputElement
        checkBox?.addEventListener("change", () => {
            this.checkboxTerrain = checkBox.checked
            this.checkBoxTerrain(this.checkboxTerrain)
        })

    }
    checkBoxTerrain = async (check: boolean) => {
        // if (check) {
        //     // Bật địa hình 

        //     this._inputMapTerrain.viewer.scene.setTerrain(Terrain.fromWorldTerrain({
        //         requestVertexNormals: true,
        //     }))

        // } else {
        //     // Tắt địa hình 
        //     this._inputMapTerrain.viewer.terrainProvider = new EllipsoidTerrainProvider()
        //     this._valueExaggeration = 1
        // }
        if (check) {
            // Bật địa hình từ Asset ID vì đang bị chặn truy cập từ IonResource
            const terrainProvider = await CesiumTerrainProvider.fromIonAssetId(1, {
                requestVertexNormals: true,
            });

            this._inputMapTerrain.viewer.terrainProvider = terrainProvider;

        } else {
            // Tắt địa hình, về ellipsoid mặc định
            this._inputMapTerrain.viewer.terrainProvider = new EllipsoidTerrainProvider();
        }
        this._inputMapTerrain.viewer.scene.requestRender()
    }
    //#endregion

    //#region  _handleCheckBoxDepth
    handleCheckBoxDepth = () => {
        const checkBox = this._containerView?.querySelector(`#terrain-depth-${this._idGeneral}`) as HTMLInputElement
        checkBox?.addEventListener("change", () => {
            this.checkboxDepth = checkBox.checked
            this.checkBoxDepth(this.checkboxDepth)

        })

    }

    checkBoxDepth = (check: boolean) => {
        if (check) {
            this._inputMapTerrain.viewer.scene.globe.depthTestAgainstTerrain = false;

        } else {
            this._inputMapTerrain.viewer.scene.globe.depthTestAgainstTerrain = true;

        }
        this._inputMapTerrain.viewer.scene.requestRender()

    }
    //#endregion


    //#region handleTransparentGlobe

    validateTransparentGlobe = (event: Event) => {

        const target = event.target as HTMLInputElement;
        const value = Number(target.value)
        this.valueTransparentGlobe = value

        this.actionTransparentGlobe(this.valueTransparentGlobe)

    }

    actionTransparentGlobe = (value: number) => {

        // const globeMateria = this._inputMapTerrain.viewer.scene.globe.material;

        // if (globeMateria) {
        //     globeMateria.destroy()
        // }

        this._inputMapTerrain.viewer.scene.globe.material = createElevationBandMaterial({
            scene: this._inputMapTerrain.viewer.scene,
            layers: [
                {
                    entries: [
                        {
                            // color: new Color(1, 1, 1, Number(this._valueTransparentGlobe)),
                            color: new Color(245 / 255, 245 / 255, 245 / 255, Number(value)),
                            height: 0
                        }
                    ],
                    extendDownwards: true,
                    extendUpwards: true,

                }
            ]
        })

        this._inputMapTerrain.viewer.scene.globe.translucency.frontFaceAlpha = Number(1.0 - value)
        this._inputMapTerrain.viewer.scene.requestRender()

    }

    //#endregion

    //#region handleActionNoneMap
    resetBeforeNoneMap: {
        checkTerrain: boolean,
        checkDepth: boolean,
        valueTranspare: number

    } = {
            checkTerrain: false,
            checkDepth: true,
            valueTranspare: 0
        }

    handleActionNoneMap = (isNoneMap: boolean) => {

        const checkBoxTerrain = this._containerView?.querySelector(`#terrain-${this._idGeneral}`) as HTMLInputElement
        const checkBoxDepth = this._containerView?.querySelector(`#terrain-depth-${this._idGeneral}`) as HTMLInputElement

        const labelTerrain = this._containerView?.querySelector(`label[for="terrain-${this._idGeneral}"]`)
        const labelDepth = this._containerView?.querySelector(`label[for="terrain-depth-${this._idGeneral}"]`)


        if (isNoneMap) {
            this.resetBeforeNoneMap.checkTerrain = checkBoxTerrain.checked
            this.resetBeforeNoneMap.checkDepth = checkBoxDepth.checked
            this.resetBeforeNoneMap.valueTranspare = Number(this.valueTransparentGlobe)

            checkBoxTerrain.disabled = true
            checkBoxDepth.disabled = true
            this._inputTransparentGlobe.disabled = true

            this._inputTransparentGlobe.classList.add('disable')
            labelTerrain?.classList.add('disable')
            labelDepth?.classList.add('disable')
            //Set lại giá trị 0 cho nonemap
            this.valueTransparentGlobe = 0
            this._inputTransparentGlobe.value = this.valueTransparentGlobe
            this.actionTransparentGlobe(this.valueTransparentGlobe)



        } else {


            checkBoxTerrain.disabled = false
            checkBoxDepth.disabled = false
            this._inputTransparentGlobe.disabled = false

            this._inputTransparentGlobe?.classList.remove('disable')
            labelTerrain?.classList.remove('disable')
            labelDepth?.classList.remove('disable')

            this.checkboxTerrain = this.resetBeforeNoneMap.checkTerrain
            this.checkboxDepth = this.resetBeforeNoneMap.checkDepth
            this.valueTransparentGlobe = this.resetBeforeNoneMap.valueTranspare
            this._inputTransparentGlobe!.value = this.resetBeforeNoneMap.valueTranspare

        }

    }
    //#endregion




}